import React from "react";

type BetaBadgeProps = {
  /** icon size in px (default 30) */
  size?: number;
  /** CSS color value for the fill (default currentColor)*/
  color?: string;
  className?: string;
};

/**
 * Beta badge derived from original MIT licenced asset https://www.svgrepo.com/svg/371716/beta
 */
const BetaBadge = ({
  size = 30,
  color = "currentColor",
  className,
}: BetaBadgeProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill={color}
    >
      <title>Beta</title>
      <desc>An early release feature that may change.</desc>
      <path d="M25.8 18h1.7l-.8-2.2z" />
      <path d="M10.4 17.5H8.5V19h1.6c.4.1.8-.2.9-.6.1-.4-.2-.8-.6-.9z" />
      <path d="M10.7 15.8c0-.4-.3-.7-.8-.7H8.5v1.3h1.4c.5.1.8-.2.8-.6z" />
      <path d="M33.1 9h-30c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h4v4c0 .4.2.8.6.9.1.1.2.1.4.1.3 0 .5-.1.7-.3l4.7-4.7h19.6c.6 0 1-.4 1-1V10c0-.6-.5-1-1-1zM10.4 20.1H7.2v-6h3c.9-.1 1.7.5 1.8 1.4v.1c0 .6-.3 1.1-.8 1.3.6.2 1.1.8 1.1 1.5-.1 1-.9 1.7-1.9 1.7zm7.5-4.9h-3.3v1.2h3v1.2h-3v1.3h3.3v1.2h-4.6v-6h4.6v1.1zm3.8 4.9h-1.3v-4.8h-1.9v-1.2h5v1.2h-1.8v4.8zm6.7 0-.4-1h-2.7l-.4 1h-1.4l2.4-6h1.4l2.5 6h-1.4z" />
      <path fill="none" d="M0 0h36v36H0z" />
    </svg>
  );
};

export default BetaBadge;
